import {
	getPlacementsOfServiceBySlug as getPlacementsOfServiceBySlugAction,
	getPlacementsOfService as getPlacementsOfServiceAction,
} from '@/store/modules/placements/actions';
import { useStore } from '@/utils/store';
import { ServiceId, ServiceSlug } from '@ply-io/ply-front-shared-utilities';

export const usePlacementsActions = () => {
	const { dispatch } = useStore();
	return {
		getPlacementsOfService: (serviceId: ServiceId, forceGet: boolean = true) =>
			dispatch<{ serviceId: ServiceId; forceGet: boolean }, void>(getPlacementsOfServiceAction, { serviceId, forceGet }),
		getPlacementsOfServiceBySlug: (slug: ServiceSlug, forceGet: boolean = true) =>
			dispatch<{ slug: ServiceSlug; forceGet: boolean }, void>(getPlacementsOfServiceBySlugAction, { slug, forceGet }),
	};
};
